import { normalizedTranslate } from '@rbilabs/components-library';
import styled from 'styled-components';

export const Grad = styled.div`
  position: sticky;
  inset-inline-start: 0;
  content: '';
  display: block;
  width: 100%;
  height: 3rem;
  pointer-events: none;
  z-index: ${Styles.zIndex.normal};

  &:first-child {
    margin-block-end: -2rem;
    inset-block-start: 0;
    background: linear-gradient(to bottom, rgba(255, 255, 255, 1) 0, rgba(255, 255, 255, 0) 100%);
  }

  &:last-child {
    margin-block-start: -2rem;
    inset-block-end: 0;
    background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 1) 100%);
  }
`;

export const DropdownContainer = styled.div<{ $visible: boolean; $insetInlineStart: number }>`
  opacity: ${p => (p.$visible ? 1 : 0)};
  position: absolute;
  inset-block-start: 78px;
  inset-inline-start: ${p => p.$insetInlineStart}px;
  width: 320px;
  display: inline-block;
  box-sizing: border-box;
  background: ${Styles.color.white};
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 10%);
  transform: ${p => (p.$visible ? 'translate(-50%, 0)' : 'translate(-50%, -1rem)')};
  transition:
    opacity 200ms ease-out,
    transform 200ms ease-out,
    visibility 200ms ease-out;
  visibility: ${p => (p.$visible ? 'visible' : 'hidden')};
  z-index: ${Styles.zIndex.top};

  & > div {
    max-height: calc(90vh - 78px);
    padding-block: 0;
    padding-inline: 2rem;

    overflow-y: auto;
  }

  &:after {
    position: absolute;
    display: block;
    content: '';
    border: medium solid ${Styles.color.white};
    border-width: 0 15px 15px 15px;
    border-color: transparent transparent ${Styles.color.white} transparent;
    inset-block-start: 1px;
    inset-inline-start: 50%;
    transform: ${normalizedTranslate('-50%', '-100%')};
  }
`;
